import http, { getApi, postApi, putApi } from "@/utils/http";
export const getCityData = () => {
  return getApi("/video/poi/city/data");
};

// 根据关键词搜索位置列表
export const getPositionByKeywordApi = (params) => {
  return getApi('/video/poi/search', params)
}

// 获取快手网页授权地址
export const getKuaishouApi = () => {
  return getApi('/video/auth/kuaishou')
}

// 获取tiktok地址
export const getTikTokApi = () => {
  return getApi('/video/auth/tiktok')
}

// 获取抖音授权地址
export const getDouyinApi = () => {
  return getApi('/video/auth/douyin')
}

// 获取bilibibli授权地址
export const getBilibiliApi = () => {
  return getApi('/video/auth/bilibili')
}

// 获取用户信息
export const getUserInfo = () => {
  return getApi('/user/info')
}

// 获取快手创建授权
export const addKuaishouAuthApi = (data) => {
  return postApi('/video/auth/kuaishou/callback',  data)
}
// 获取抖音创建授权
export const addDouyinAuthApi = (data) => {
  return postApi('/video/auth/douyin/callback',  data)
}

// 获取tiktok创建授权
export const addTiktokAuthApi = (data) => {
  return postApi('/video/auth/tiktok/callback', data)
}

// 获取bilibibli创建授权
export const addBilibiliAuthApi = (data) => {
  return postApi('/video/auth/bilibili/callback', data)
}


// 获取用户头像
export async function getUserAvatarUrl(url: string): Promise<any> {
  return getApi(`/space/oss/url?oss_key=${url}`);
}

// 获取二维码地址
export async function getCode(id: string): Promise<any> {
  return getApi(`/video/task/code?task_id=${id}`);
}

//修改poi门店地址
export function patchAddressApi({id, data}): Promise<any> {
  return putApi(`/video/auth/${id}/address`, data);
}

export const createProject = async (data: {
  name: string;
  memberIds: string[];
}): Promise<number> => {
  const result = await http.post(`/space/project`, {
    name: data.name,
    member_uuid: data.memberIds,
  });
  return result.data.id;
};
// 修改项目
export const editProjectProject = async (data: {
  name: string;
  id: number;
  memberIds?: string[];
}) => {
  const result = await http.put(`/space/project/${data.id}`, {
    name: data.name,
    member_uuid: data.memberIds || [],
  });
  return result;
};

export interface ICreatePortfolioFolderRequest {
  path: string;
  project_id: number;
}

// 新建成片文件夹
export const createPortfolioFolder = async (
  data: ICreatePortfolioFolderRequest,
) => {
  const result = await http.post(`/space/composition`, {
    ...data,
  });
  return result;
};

// 修改名称
export const portfolioRename = async (id: number, name: string) => {
  return await http.put(`/space/composition/${id}`, {
    name,
  });
};

// 获取所有项目列表
export const getProjectList = async (name?: string) => {
  try {
    const result = await http.get(`/space/project?keyword=${name}`);
    return result.data.items || [];
  } catch (err) {
    return [];
  }
};

export interface IGetAllPortfolioFolderRequest {
  created_at: number;
  id: number;
  level: number;
  name: string;
  parent_id: number;
  project_id: number;
  team_id: number;
  updated_at: number;
}
export const getAllPortfolioFolder = async (): Promise<
  IGetAllPortfolioFolderRequest[]
> => {
  const result = await http.get(`/space/composition/all`);
  return result.data.items;
};
